import { Component, ElementRef, Input, ViewChild, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-pdf-viewer',
  imports: [],
  templateUrl: './pdf-viewer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './pdf-viewer.component.scss',
})
export class PDFViewerComponent implements AfterViewInit {
  @Input({ required: true })
  blob!: Blob;

  @Input({ required: true })
  filename!: string;

  @ViewChild('visionneusepdf', { static: false }) myElement!: ElementRef;

  ngAfterViewInit() {
    this.convertBlobToBase64(this.blob).then(base64 =>
      this.myElement.nativeElement.setAttribute('data', base64 + '#toolbar=1&view=FitV,100'),
    );
  }
  convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }
}
